import React, { useEffect, useState } from 'react';
import { Modal, Button } from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form";
import { GetDictionary } from '../utilities/CommonFunctions';
const SessionExpiredAlert = () => {
  var interval;
  var interval_continiue = globalThis.config.Settings.interval_continiue;
  const [show, setShow] = useState(false);
  const [dic_lng, setdic_lng] = useState({});



  const ru_handleClose = () => setShow(false);
  const { control, register, handleSubmit, setValue, setError, formState: { errors } } = useForm({ });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "form"
  });
  useEffect(() => {
    async function callfunc() {
      let d = await GetDictionary("1,3,5,6,9,11,12,15");
      setdic_lng(d);
    }
    callfunc()

    async function waitforcontinue() {
      localStorage.setItem("timer", 0);
      localStorage.setItem("curr_date", new Date('24-May-9999 00:02:00'));
      interval = setInterval(function () {
        if (localStorage.getItem("modelpopup_open") == '1') {
          localStorage.setItem("timer", parseInt(localStorage.getItem("timer")) + 1);
          if (parseInt(localStorage.getItem("timer")) === interval_continiue) {
            clearInterval(interval);
            LogOff();
          }
          else {
            if (document.getElementById("remaining_time") != null) {
              let curr_date = new Date(new Date(localStorage.getItem("curr_date")) - (1 * 1000));
              localStorage.setItem("curr_date", curr_date);
              document.getElementById('remaining_time').innerHTML = curr_date.getMinutes() + " min " + curr_date.getSeconds() + ' secs';
            }
          }

        }
      }, 1000);
    }
    waitforcontinue();
  }, []);
  const ClickHandler = async () => {
    interval_continiue = globalThis.config.Settings.interval_continiue;
    localStorage.setItem("timer", 0);
    localStorage.setItem("curr_date", new Date('24-May-9999 00:02:00'));
    setShow(true)
  }
  const Continue = () => {

    interval_continiue = globalThis.config.Settings.interval_continiue;
    localStorage.setItem("timer", 0);
    localStorage.setItem("curr_date", new Date('24-May-9999 00:02:00'));
    localStorage.setItem("modelpopup_open", '0');
    clearInterval(interval);
    setShow(false);
    return false;
  };

  const LogOff = () => {
    try{
      clearInterval(interval);
      localStorage.setItem("timer", 0);
      localStorage.setItem("modelpopup_open", '0');
      document.getElementById('remaining_time').innerHTML = "0 min " + '0 secs';
      localStorage.setItem("modelpopup_open", '0');
      localStorage.clear();
      window.location.pathname = globalThis.config.Settings.ApiConfiguration.BaseURL+"/";
    }catch{
      console.log("innerHTML");
    }
    
  };
  return (
    <>
      <a id='btnsessionexpired' onClick={(e) => ClickHandler(e)}
        href={void (0)}
        className="btn btn-light btn-sm mx-1 d-none" >
      </a>
      <Modal id="modelpopup" show={show} onHide={ru_handleClose} centered backdrop="static" >
        <form className="theme-form">
          <Modal.Header closeButton>
            <Modal.Title className='text-uppercase'>Warning</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row theme-form">
              <div className="loginContainer">
                <p className='font-16'> Due to inactivity your session will automatically timeout in <br /> <span id="remaining_time">1 min 59 secs.</span>.</p>
              </div>
            </div>
            <div >
            </div>
          </Modal.Body>
          <Modal.Footer>
            <a className="btn btn-outline-success" style={{ "width": "200px" }} onClick={LogOff} >Logout</a>
            <a className="btn btn-success" style={{ "width": "200px" }} onClick={Continue} >Stay Connected</a>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  )
}
export default SessionExpiredAlert;